<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'PROVIDER-DIRECTORY'" [breadcrumb]="''" [count]="count"
    icon="fa-users-medical">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="providerGridAutoExpandSwitch" [storageKey]="'providers-list-expand'"
                    [titleKey]="'AUTO-EXPAND'" (collapsibleToggle)="enableAutoExpand=$event" class="mr-4">
                </app-advanced-mode>
                <app-advanced-mode id="providersGridAdvancedSwitch" [storageKey]="'providers-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NAME' | translate }}"
                    (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-NAME' | translate }}" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView"
            [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true" [navigable]="true"
            [reorderable]="enableAdvanced" [kendoGridSelectBy]="" (dataStateChange)="dataStateChange($event)"
            (cellClick)="onCellClick($event)" [selectable]="{ mode: 'single' }">
            <kendo-grid-messages noRecords="{{ 'NO-PROVIDERS' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="fullName" title="{{'NAME' | translate}}" [width]="65">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <div class="ellipsis-text" title="{{getProviderName(dataItem)}}">
                        {{getProviderName(dataItem)}}
                    </div>
                    <div *ngIf="dataItem.directAddress" class="directAddress montserrat ellipsis-text"
                        title="{{dataItem.directAddress}}">
                        <i class="fas fa-copy mr-1" style="font-size: initial; cursor: pointer;"
                            title="{{'COPY' | translate}}" (click)="copyDirectAddress(dataItem.directAddress)">
                        </i>&nbsp;{{dataItem.directAddress}}
                    </div>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="organization" title="{{ 'ORGANIZATION' | translate }}" [width]="60">
            </kendo-grid-column>
            <kendo-grid-column field="genderName" title="{{ 'GENDER' | translate }}" [width]="50" [hidden]="true">
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-dropdown-filter [filter]="filter" [data]="genders" filterField="genderName"
                        textField="displayName" valueField="displayName">
                    </app-dropdown-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="specialtyName" title="{{ 'SPECIALTY' | translate }}" [width]="60">
            </kendo-grid-column>
            <kendo-grid-column field="email" title="{{ 'EMAIL' | translate }}" [width]="70">
            </kendo-grid-column>
            <kendo-grid-column field="telephoneNumber" title="{{ 'PHONE' | translate }}" [width]="55">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.telephoneNumber | phone}}</span>
                    <span *ngIf="dataItem.telephoneNumberExtension">&nbsp;{{'PHONE-EXTENSION-PREFIX' |
                        translate}}&nbsp;{{dataItem.telephoneNumberExtension}}</span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-phone-filter [filter]="filter" filterField="telephoneNumber"
                        [phoneNumberMask]="phoneNumberMask">
                    </app-phone-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="cellPhoneNumber" title="{{ 'CELL' | translate }}" [width]="55" [hidden]="true">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{dataItem.cellPhoneNumber | phone}}</span>
                </ng-template>
                <ng-template kendoGridFilterCellTemplate let-filter>
                    <app-phone-filter [filter]="filter" filterField="cellPhoneNumber"
                        [phoneNumberMask]="phoneNumberMask">
                    </app-phone-filter>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="npi" title="{{ 'PROVIDER-NPI' | translate }}" [width]="60">
            </kendo-grid-column>
            <kendo-grid-column field="qualityScore" title="{{ 'QUALITY-SCORE' | translate }}" [width]="40"
                filter="numeric" [hidden]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                    <kendo-grid-numeric-filter-cell [column]="column" [filter]="filter" [spinners]="false">
                    </kendo-grid-numeric-filter-cell>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column [width]="30" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i *ngIf="!isDirectoryManager" class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'], dataItem['npi'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
            <ng-template kendoGridDetailTemplate let-dataItem
                [kendoGridDetailTemplateShowIf]="showDetailsOnlyIfAddress">
                <section *ngIf="dataItem.practiceAddress" class="ml-3">
                    <div *ngIf="dataItem.practiceAddress.streetLine">{{dataItem.practiceAddress.streetLine}}</div>
                    <div *ngIf="dataItem.practiceAddress.streetLineAdditional">
                        {{dataItem.practiceAddress.streetLineAdditional}}</div>
                    <div>
                        <span *ngIf="dataItem.practiceAddress.city">{{dataItem.practiceAddress.city}},&nbsp;</span>
                        <span *ngIf="dataItem.practiceAddress.county">{{dataItem.practiceAddress.county}},&nbsp;</span>
                        <span *ngIf="dataItem.practiceAddress.state">{{dataItem.practiceAddress.state}}&nbsp;</span>
                        <span *ngIf="dataItem.practiceAddress.postalCode">{{dataItem.practiceAddress.postalCode}}
                        </span>
                    </div>
                    <div *ngIf="dataItem.practiceAddress.country">
                        {{dataItem.practiceAddress.country}}
                    </div>
                </section>
            </ng-template>
        </kendo-grid>
        <button kendoButton *ngIf="!isDirectoryManager" [primary]="false" type="button" (click)="addHandler()"
            class="float-right mt-3 mb-3 ml-3">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
        <button kendoButton *ngIf="!isDirectoryManager" type="button"
            title="{{'IMPORT-PROVIDERS-FROM-CSV' | translate}}" (click)="openProvidersImport()"
            class="float-right mt-3 mb-3 ml-3">{{'IMPORT' | translate}}<i class="far fa-file-import"></i>
        </button>
        <button kendoButton type="button" title="{{'EXPORT-PROVIDERS-TO-CSV' | translate}}"
            (click)="exportProviderToCsv()" class="float-right mt-3 mb-3 ml-3">{{'EXPORT' | translate}}<i
                class="far fa-file-export"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-provider-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-provider-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{getProviderName(selectedProvider)}}</span>
    <div class="deletion-warning mt-4" *ngIf="providerInUse">{{'PROVIDER-IN-USE-WARNING' | translate }}
    </div>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<app-provider-import (loadedProviders)="onLoadedProviders()" #importProviders></app-provider-import>